let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("knPTc")).then(() => parcelRequire('eqvx9'));